import { render, staticRenderFns } from "./info-screening-patient.vue?vue&type=template&id=3df5a994&"
import script from "./info-screening-patient.vue?vue&type=script&lang=js&"
export * from "./info-screening-patient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports